import { create } from "zustand";
import axios from "../api/axiosInstance";

const MOCK_BLOGS = [
  {
    _id: "mock-1",
    title: "Building Scalable AI Automations with n8n and OpenAI",
    category: "AI & Automation",
    content: "Enterprise workflow automation is about more than calling a simple API. In this guide, we dive into building robust event-driven systems using n8n and OpenAI. We outline how to orchestrate webhooks, design system instructions, parse JSON arrays, and handle state persistence to automate lead routing with zero downtime.",
    createdAt: new Date("2026-07-01").toISOString(),
    author: "Chahat Jain",
    tags: ["AI", "n8n", "OpenAI", "Node.js"]
  },
  {
    _id: "mock-2",
    title: "Mastering Salesforce Apex Triggers and REST Callouts",
    category: "Salesforce",
    content: "Integrating external APIs with Salesforce requires an understanding of governor limits and transaction boundaries. Learn how to write bulkified Apex triggers, run asynchronous Callouts using Queueable and Future jobs, and establish secure JWT token authentication schemes to keep CRM and database layers synchronized.",
    createdAt: new Date("2026-06-15").toISOString(),
    author: "Chahat Jain",
    tags: ["Salesforce", "Apex", "Integration", "APIs"]
  },
  {
    _id: "mock-3",
    title: "Optimizing Next.js SSR and Database Queries for Scale",
    category: "Full Stack SDE",
    content: "Performance is a feature. In this post, we discuss specific engineering strategies used to speed up page rendering. We review MongoDB aggregation indices, Redis memory key caching, and Next.js Server-Side Rendering configurations that helped StockPilot achieve a 35% sync speed optimization.",
    createdAt: new Date("2026-05-20").toISOString(),
    author: "Chahat Jain",
    tags: ["Next.js", "MongoDB", "Node.js", "Performance"]
  }
];

const useBlogStore = create(
  (set, get) => ({
    blogs: [],
    page: 1,
    hasMore: true,
    loading: false,
    error: null,
    loaded: false,

    // replace full list
    setBlogs: (newBlogs) =>
      set({ blogs: Array.isArray(newBlogs) ? newBlogs : [] }),

    // append with dedupe
    appendBlogs: (moreBlogs) =>
      set((state) => {
        const list = Array.isArray(moreBlogs) ? moreBlogs : [];
        const existingIds = new Set(state.blogs.map((b) => b._id));
        const filtered = list.filter((b) => !existingIds.has(b._id));
        return { blogs: [...state.blogs, ...filtered] };
      }),

    clearBlogs: () => set({ blogs: [], page: 1, hasMore: true }),

    updateBlogInList: (updated) =>
      set((state) => ({
        blogs: state.blogs.map((b) =>
          b._id === updated._id ? { ...b, ...updated } : b
        ),
      })),

    // fetch blogs ONCE only (for homepage preload)
    fetchBlogs: async () => {
      const { loaded } = get();
      if (loaded) return; // already fetched once

      try {
        set({ loading: true });

        const res = await axios.get("/blog?page=1&limit=6"); // homepage preload
        const blogList = res.data && res.data.length > 0 ? res.data : MOCK_BLOGS;
        set({
          blogs: blogList,
          loaded: true,
          page: 1,
          hasMore: res.data && res.data.length === 6,
        });
      } catch (err) {
        console.error("Failed to preload blogs, loading offline content.", err);
        set({
          blogs: MOCK_BLOGS,
          loaded: true,
          error: null,
          page: 1,
          hasMore: false,
        });
      } finally {
        set({ loading: false });
      }
    },
  })
);

export default useBlogStore;
